export default __webpack_public_path__ + "static/report-content-03-109601111b0a9f7b8877292dcd0abb4d.png";